<template>
    <div>
    	<table class="room-table" cellspacing="0">
            <thead>
                <tr>
                    <td>Sun.</td>
                    <td>Mon.</td>
                    <td>Tues.</td>
                    <td>Wed.</td>
                    <td>Thur.</td>
                    <td>Fri.</td>
                    <td>Sat.</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="week in tableData">
                    <td :class="getDaysSize(today,day.PD)>=0?(day.S=='026001'?'change-room cursorPointer':'change-room close cursorPointer'):'before-day' " v-for="day in week" @click="toRoomStatusSingleEdit(day)">
                        <div v-if="day">
                            <i v-if="getDaysSize(today,day.PD)>=0&&day.S!='026001'&&day.S"></i>
                        
                            <h3>
                                <span class="font16"> {{day.AP}}</span>
                            </h3>
                            <p v-show="!day.C">
                                <label v-show="day.CD!=null" class="font12">{{day.CD>0?'In advance '+day.CD +' day ':'Intraday '}}</label>
                                <label v-show="day.CT" class="font12">{{day.CT}} cancel</label>
                                
                                <!-- {{day.CD>0?'提前'+day.CD +'天':'当天'}}{{day.CT}}前取消 -->
                            </p>
                            
                            <p v-show="day.C"><span class="one font12">Non-Refundable</span></p>
                          
                            <span class="day">{{getDateDay(day.PD)}}</span>
                        </div>
                    </td>
                </tr>


            </tbody>
        </table>
        <RoomPriceSingleEdit :cmData="cmSingleData" :rps="cmRps" @initTable="initTable"></RoomPriceSingleEdit>
 
    </div>

</template>
<script>

import RoomPriceSingleEdit from './roomPriceEdit/RoomPriceSingle.vue'

export default {
    name:'datePriceTable',
    components:{
        RoomPriceSingleEdit,
        
    },
    props:{
        date: {
            type: String,
            default:''
        },
        rps:{
            type:Object,
            default:function(){
                return{}
            }
        }
    },
    data(){
        return{
            cmRps:{},
            tableData:'',
            cmDate: '',
            cmSingleData: {},
            today:this.getDate(0)
        }
    },
    watch:{
        date(val){
           
            this.cmDate=val+'01';
            this.initTable();

        },
        rps(val){
            this.cmRps=val;
            
            this.initTable();
        }
    },
    methods:{
        //获取月份的数据
        initTable(){
            
            var that=this;
            var cmRps=that.cmRps;
            var params={
              hotel: cmRps.HotelId,
              room: cmRps.RoomId,
              rp: cmRps.RatePlanId,
              rate: cmRps.RateId,
              date: that.cmDate,
            }
            that.isLoading = true;
            that.getRequest({
                url: that.Api.getRp,
                params: params
            }).then(res => {
                that.isLoading = false;
                if (res && res.length>0) {
                   that.toConfigTableData(res);//处理表格日期数据                  
                } else {
                    that.tableData='';
                    that.error({ title: 'Tips', content: 'No data is queried' });
                }
            });
        },

        //将数据格式化表格日期格式
        toConfigTableData(data){
            var data=data;
            var weekday=this.getWeekday(data[0].PD);
            for(var i=0;i<weekday;i++){
                 data.unshift('');
            }
            var result = [];
            //补全日期前几天
            for(var i=0,len=data.length;i<len;i+=7){
               result.push(data.slice(i,i+7));
            }
            //补全日期后几天
            var length=result[(result.length-1)].length;
            if(length<7){
                for(var i=0;i<(7-length);i++){
                    result[(result.length-1)].push('');
                }
            }
            this.tableData=result;
        },
        //获取日期中的天
        getDateDay(date){
            var date=date;
            var day=date.split('/')[2];
            return day

        },
        //编辑单独一天的房态
        toRoomStatusSingleEdit(day){
            
            if(this.getDaysSize(this.today,day.PD)<0)return;//先判断当期日期是否可以编辑
            let Data=JSON.parse(JSON.stringify(day));
      
            if(Data.CD==null||Data.CD==''||Data.CD==0){
                Data.CD=0

            }
            if(Data.CT==null||Data.CT==''||Data.CT==0){
                Data.CT='17:00'

            }

            this.cmSingleData=Data;
            this.$nextTick(function () {
                this.$set(this.cmSingleData,'isShow',true);
            });
            
        }
       
    },
    mounted(){
        this.cmRps=this.rps;
        this.cmDate=this.date+'01';
        
        this.initTable();
    }

}
</script>












// WEBPACK FOOTER //
// src/components/roomPrice/psComponent/datePriceTable.vue